export default "__VITE_ASSET__AbS4nrqw__"